import axios from 'axios'

const API = axios.create({baseURL:'https://stackoverflowserver.herokuapp.com'})

API.interceptors.request.use((req) => {
    if(localStorage.getItem('Profile')){
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem('Profile')).token}`
    }
    return req;
})


export const logIn = (authData) => API.post('/user/login', authData);
export const signUp = (authData) => API.post('/user/signup', authData);

export const postQuestion = (questionData) => API.post('/questions/Ask',questionData);
export const getAllQuestions = () => API.get('/questions/get');
export const deleteQuestion = (id) => API.delete(`/questions/delete/${id}`);

export const postAnswer = (id, noOfAnswers, answerBody, userAnswered, userId ) => API.patch(`/answer/post/${id}`, { noOfAnswers, answerBody, userAnswered, userId })
export const deleteAnswer = (id, answerId, noOfAnswers) => API.patch(`/answer/delete/${id}`,{answerId,noOfAnswers});

export const voteQuestion = (id, value, userId) => API.patch(`/questions/vote/${id}`,{value,userId})

export const getAllUsers = () => API.get('/user/getAllUsers');
export const updateProfile = (id, updateData) => API.patch(`/user/update/${id}`, updateData)

export const postComment = (id,commentBody,userCommented,userId,answerId) => API.patch(`/answer/postComment/${id}`, {commentBody,userCommented,userId,answerId})
export const tagData = (tagData) => API.post('/questions/tagged',{tagData})
